import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import ActivityACHPage, { getDefaultData } from "components/pages/ActivityACHPage";
import Classes, { ACHBatch } from "model";

export default function CaptureApprovalsPendingDefault(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const { pendingSameDayACHBatchesWidgetData } = getDefaultData();
    const { achBatches } = pendingSameDayACHBatchesWidgetData ?? {};
    
    const defaultACH = achBatches[0] ?? {};
    const cloneACH = BCMSStateManagerCRUD.init(ACHBatch.init(defaultACH.record))
        .update([ "referenceNumber" ], "121243")
        .update([ "creditAmount", "amount" ], "5000.0")
        .update([ "debitAmount", "amount" ], "5000.0")
        .update([ "id" ], "1")
        .submit();

    const data = BCMSStateManagerCRUD.init(getDefaultData())
        .update([ "pendingSameDayACHBatchesWidgetData", "achBatches" ], [ defaultACH, cloneACH ])
        .submit();

    return <ActivityACHPage data={ data } />
}